import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Textfield } from '@scentregroup/ui'
import classNames from 'classnames'
import analyticsUtils from '../../../helpers/analytics-utils'
import style from './index.scss'

const getMatchingItems = ({ items, searchValue }) =>
  items.filter(item =>
    item.value.toUpperCase().includes(searchValue.toUpperCase())
  )

class ExpandableList extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.items.length === prevState.items.length) {
      return null
    } else {
      return Object.assign({}, prevState, { items: nextProps.items })
    }
  }

  constructor(props) {
    super(props)

    this.state = {
      isExpanded: false,
      items: props.items,
      searchValue: '',
    }
  }

  handleClick = () => {
    const expanded = !this.state.isExpanded
    analyticsUtils.gaTagTracking({
      event: this.props.analyticsEvent,
      eventCategory:
        this.props.analyticsEventCategory ||
        analyticsUtils.categories.PRODUCT_FILTER,
      eventAction: this.props.analyticsEventAction,
      eventLabel: expanded ? 'See More' : 'See Less',
    })
    this.setState({ isExpanded: expanded })
  }

  handleSearch = event => {
    this.filterList({ searchValue: event.target.value })
  }

  filterList = ({ searchValue = this.state.searchValue }) => {
    this.setState({
      items: getMatchingItems({
        items: this.props.items,
        searchValue,
      }),
      searchValue,
    })
  }

  render() {
    const { items, isExpanded } = this.state
    const { size, topic, isSearchable } = this.props

    return (
      <div
        className={classNames(style.expandableList, {
          [style.expanded]: isExpanded,
        })}
      >
        {isSearchable && (
          <Textfield
            classNames={style}
            maxLength={24}
            value={this.state.searchValue}
            placeholder={topic ? `Find a ${topic}` : 'Filter'}
            onChange={this.handleSearch}
          />
        )}
        <ul>
          {items.slice(0, size).map((item, index) => (
            <li className={style.linkItem} key={index}>
              <Link
                to={item.link}
                onClick={() => item.onClick(this.state.searchValue)}
              >
                {item.value}
              </Link>
            </li>
          ))}
          {items.length > size && !isExpanded && (
            <li>
              <button
                className={style.seeMoreLess}
                onClick={() => this.handleClick()}
              >
                See {items.length - size} more {topic || 'items'}
              </button>
            </li>
          )}
          {isExpanded &&
            items.slice(size, items.length).map((item, index) => (
              <li className={style.linkItem} key={index}>
                <Link
                  to={item.link}
                  onClick={() => item.onClick(this.state.searchValue)}
                >
                  {item.value}
                </Link>
              </li>
            ))}
          {isExpanded && (
            <li>
              <button
                className={style.seeMoreLess}
                onClick={() => this.handleClick()}
              >
                See Less
              </button>
            </li>
          )}
        </ul>
      </div>
    )
  }
}

ExpandableList.propTypes = {
  size: PropTypes.number,
  items: PropTypes.array.isRequired,
  topic: PropTypes.string,
  isSearchable: PropTypes.bool,
  analyticsEvent: PropTypes.string.isRequired,
  analyticsEventAction: PropTypes.string.isRequired,
  analyticsEventCategory: PropTypes.string,
}

export default ExpandableList
